import * as Yup from 'yup';

// Contact number regex - allows various formats
const contactRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/;

// Email validation regex
const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const employeeValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be less than 50 characters"),
  
  lastName: Yup.string()
    .required("Last name is required")
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be less than 50 characters"),
  
  email: Yup.string()
    .required("Email is required")
    .matches(emailRegex, "Invalid email format")
    .test('email-unique', 'This email is already registered', async function(value) {
      // Note: In production, this should verify against database
      // For now, we'll just validate format
      return true;
    }),
  
  contact: Yup.string()
    .required("Contact number is required")
    .matches(contactRegex, "Invalid contact number format")
    .min(10, "Contact number must be at least 10 digits")
    .max(15, "Contact number must be less than 15 digits"),
  
  address: Yup.string()
    .required("Address is required")
    .max(200, "Address must be less than 200 characters"),
  
  // branchId is optional for owner creation
  branchId: Yup.string().nullable(),
  
  companyId: Yup.string().required("Company is required"),
  
  // Optional fields with validation
  nic: Yup.string()
    .max(20, "NIC must be less than 20 characters")
    .nullable(),
  
  empNo: Yup.string()
    .max(50, "Employee ID must be less than 50 characters")
    .nullable(),
});
